import type { TenantRole } from '@detect/shared';
import type { TenantSummaryLike } from './mergeTenants';

/** How a management grant (#16) reads in the UI: the role cap and the client scope, in plain words. */

const ROLE_NAMES: Record<TenantRole, string> = {
  viewer: 'Viewer',
  agent: 'Agent',
  supervisor: 'Supervisor',
  admin: 'Admin',
  account_admin: 'Account admin',
};

export function managedScopeText(clientIds: string[] | null): string {
  if (clientIds === null) return 'all clients';
  return `${clientIds.length} client${clientIds.length === 1 ? '' : 's'}`;
}

/** "Viewer · all clients" */
export function managedAccessText(t: Pick<TenantSummaryLike, 'role' | 'clientIds'>): string {
  return `${ROLE_NAMES[t.role]} · ${managedScopeText(t.clientIds)}`;
}

/** "Managing Acme MSP as Night Owl Support · Viewer · all clients" (the provider's name when it is known). */
export function managingIndicatorText(
  t: Pick<TenantSummaryLike, 'name' | 'role' | 'clientIds'>,
  providerName: string | undefined
): string {
  return `Managing ${t.name}${providerName ? ` as ${providerName}` : ''} · ${managedAccessText(t)}`;
}
